import { render, staticRenderFns } from "./GreatingPrinciple.vue?vue&type=template&id=44a37929"
import script from "./GreatingPrinciple.vue?vue&type=script&lang=js"
export * from "./GreatingPrinciple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports